import { 
    LIMPA_DEFINICOES_SEGURADO, 
    SET_OPEN_BUSCA_AVANCADA, 
    SET_PARAMS_FILTER_IMPORTACAO, 
    SET_PARAMS_FILTER_RELACOES_PREVIDENCIARIAS,
    SET_PARAMS_FILTER_RESTITUICAO,
    SET_PARAMS_FILTER_RESULTADOS,
    SET_TAB_INDEX 
} from "../../actionTypes"

export const limpaDefinicoesSegurado = () => {
    return { 
        type: LIMPA_DEFINICOES_SEGURADO
    }
}

export const setTabIndex = (index) => {
    return {
        type: SET_TAB_INDEX,
        payload: { index }
    }
}

export const setParamsFilterImportacao = (params, reset = false) => {
    return { 
        type: SET_PARAMS_FILTER_IMPORTACAO,
        payload: { params, reset }
    }
}

export const setOpenBuscaAvancada = (open = false) => {
    return { 
        type: SET_OPEN_BUSCA_AVANCADA,
        payload: { open }
    }
}

export const setParamsFilterRelacoesPrevidenciarias = (params, reset = false) => {
    return { 
        type: SET_PARAMS_FILTER_RELACOES_PREVIDENCIARIAS,
        payload: { params, reset }
    }
}

export const setParamsFilterResultados = (params, reset = false) => {
    return { 
        type: SET_PARAMS_FILTER_RESULTADOS,
        payload: { params, reset }
    }
}

export const setParamsFilterRestituicao = (params, reset = false) => {
    return { 
        type: SET_PARAMS_FILTER_RESTITUICAO,
        payload: { params, reset }
    }
}